<template>
  <div class="delete-modal-mask">
      <div class="delete-modal-wrapper">
        <div class="delete-modal-container">

          <div class="delete-modal-header">
            <div>
              <h5>¿Quieres borrar el contenido?</h5>
            </div>
          </div>

          <div class="delete-modal-body">
            <p>Al borrar un contenido, también se borrarán sus estadísticas, y en caso de estar activo desaparecera del portal cautivo.</p>
          </div>
            <ul class="card">
              <li class="img-item">
                <div class="img-content">
                  <img :src="imageUrl+image" alt="">
                </div>
              </li>
              <li class="title-descr">
                <p class="title">{{title}}</p>
                <p class="description">{{desc}}</p>
              </li>
              <li class="category">
                <span class="img-cat category-1" v-if="cat==1"></span>
                <span class="img-cat category-2" v-if="cat==2"></span>
                <span class="img-cat category-3" v-if="cat==3"></span> 
                <p class="category-name" v-if="cat==1">Tarjetas</p>
                <p class="category-name" v-if="cat==2">Inversiones</p>
                <p class="category-name" v-if="cat==3">Seguros</p>   
              </li>

              <li class="interaction" v-if="interaction==1">Enlace</li>
              <li class="interaction" v-if="interaction==2">Mail</li>
              <li class="interaction" v-if="interaction==3">Contacto</li>
              <!-- <li class="start-end-date">
                <p>del {{startdate}}</p>
                <p>al {{startdate}}</p>
              </li> -->
            </ul>
          <div class="delete-modal-footer">
            <button class="button md ghost black" @click="hideModal">
              <p>Cancelar</p>
            </button>
            <button class="button md danger" @click="deleteContent">
              <p>Borrar</p>
            </button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: 'deleteContent-modal',
  components:{},
  props: {
    title: {
      type: String,
      required: true
      // default: "Contenido sin título",
    },
    image: {
      type: String,
      default: "@/assets/no-img.png",
    },
    desc: {
      type: String,
      // default: "Contenido sin descripción",
    },
    startdate: {
      type: String,
      default: "---",
    },
    enddate: {
      type: String,
      default: "---",
    },
    interaction: {
      type: Number,
      default: "---",
    },
    cat: {
      type: Number,
      required: true,
      default: 1
    },
    offer_id: {
      type: Number,
      required: true
    }
  },
  methods: {
    hideModal: function(){
      this.$emit('closeModal');
    },
    deleteContent: function(){

      this.deleteOffer(this.offer_id)
      this.$emit('closeModal');

    },
    ...mapActions('offers', [
      'deleteOffer'
    ])
  },
  computed: {
        imageUrl: function() {
            return process.env.VUE_APP_CORE_HOST
        }
    }
}
</script>

<style lang="sass">
.delete-modal-mask
  font-family: Montserrat
  position: fixed
  z-index: 99998
  top: 0
  left: 0
  width: 100%
  height: 100%
  background-color: rgba(0, 0, 0, .5)
  display: table
  transition: opacity .3s ease
  text-align:center
.delete-modal-wrapper
  display: table-cell
  vertical-align: middle
.delete-modal-container
  max-width: 700px
  border-radius: 8px
  box-shadow: 0 2px 10px 0 rgba(173, 182, 212, 0.45)
  background-color: #ffffff
  margin: 0 auto
  padding: 24px 12px
  transition: all .3s ease
  @media (max-width: $tablet)
    max-width: calc(100% - 40px)
    margin: 0 8px
.delete-modal-header
  text-align: center
.delete-modal-header i
  color: #c90b2f
  font-size: 72px
.delete-modal-body 
  text-align: center
  margin: 20px 0
.delete-modal-body p
  font-size: 16px
  font-family: $body-font
.delete-modal-footer
  width: 100%
  display: flex
  justify-content: center
.delete-modal-footer .button
  margin: 8px
.modal-enter
  opacity: 0
.modal-leave-active
  opacity: 0
.modal-enter .logout-modal-container,
.modal-leave-active .logout-modal-container
  -webkit-transform: scale(1.1)
  transform: scale(1.1)
.delete-modal-wrapper
  .card
    box-sizing: border-box
    padding: $xxs
    margin: 32px 8px
    border-radius: 4px
    align-items: center
    display: flex
    position: relative
    flex-direction: row
    justify-content: flex-start
    font-family: $title-font
    font-size: 10px
    border: 1px solid rgba(0,0,0,0)
    &:hover
      border: 1px solid #E5EDF4
      box-sizing: border-box
    li
      list-style-type: none
      text-align: center
    div
      display: flex
      flex: row wrap
    .img-item
      width: 56px
      display: flex
      justify-content: center
      .img-content
        width: 56px
        height: 56px
        background-size: cover
        display: flex
        position: relative
        overflow: hidden
        img 
          width: 100%
          height: auto
          display: flex
          align-self: center
    .title-descr
      height: 56px
      display: flex
      flex-direction: column
      align-content: flex-start
      padding: 0 $xs
      width: calc(100%/3)
      .title
        font-weight: bold
        text-align: left
      .description
        font-weight: 300
        text-align: left
    .category
      flex-direction: column
      width: calc(100%/4)
      .icon
        display: flex
    .interaction
      width: calc(100%/6)
      margin: 0 $xs
    .start-end-date
      width: calc(100%/6)
      box-sizing: border-box
      padding: 0 0 0 $sm


</style>


